import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Welcome from "@/components/Welcome";
import FitCheck from "@/components/FitCheck";
import Saeulen from "@/components/Saeulen";

import Conditions from "@/components/Conditions";


import Pricing from "@/components/Pricing";
import PraxisGalerie from "@/components/PraxisGalerie";
import Concept from "@/components/Concept";
import About from "@/components/About";
import Footer from "@/components/Footer";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import CookieConsent from "@/components/CookieConsent";
import AdventHint from "@/components/AdventHint";
import { useSeo } from "@/lib/seo";
import { useT, useLang } from "@/i18n";
import {
  localBusinessJsonLd,
  personJsonLd,
  webSiteJsonLd,
  homeWebPageJsonLd,
  BESCHWERDEN_KEYWORDS,
} from "@/lib/schema";

const Index = () => {
  const lang = useLang();
  const t = useT(
    {
      title: "Komplementärtherapie Wien | Mikrobiom & Darm – PRAXIS IB",
      description:
        "Komplementärtherapie Wien bei Reizdarm, Morbus Crohn, Colitis ulcerosa, SIBO, Endometriose, Zystitis, Neurodermitis, Fibromyalgie & chronischen Infekten.",
      ogAlt: "PRAXIS IB – Komplementärtherapie in Wien",
    },
    {
      title: "Complementary Medicine Vienna | Gut & Microbiome – PRAXIS IB",
      description:
        "Complementary medicine in Vienna for IBS, Crohn's disease, ulcerative colitis, SIBO, endometriosis, cystitis, eczema, fibromyalgia and recurrent infections.",
      ogAlt: "PRAXIS IB – complementary medicine in Vienna",
    },
  );

  useSeo({
    title: t.title,
    description: t.description,
    keywords: BESCHWERDEN_KEYWORDS,
    canonical: "/",
    ogImageAlt: t.ogAlt,
    ogImageWidth: 1200,
    ogImageHeight: 630,
      jsonLd: [
        localBusinessJsonLd,
        personJsonLd,
        webSiteJsonLd,
        homeWebPageJsonLd,
      ],
    jsonLdId: "home-jsonld",
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <AdventHint />
        <Welcome />
        <Saeulen />
        <FitCheck />
        <Conditions />
        <Concept />
        <About />
        <Pricing />

        <PraxisGalerie />
        <Testimonials />
        <Contact />
        <Footer />
      </main>
      <CookieConsent />
    </div>
  );
};

export default Index;
